import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="apidocs-test"
export default class extends Controller {
  static targets = [
    "form",
    "httpMethod",
    "url",
    "apiToken",
    "json",
    "request",
    "result",
  ];

  connect() {
  }

  showSpinner() {
    this.resultTarget.innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
  }

  validateInput() {
    const url = this.urlTarget.value
    const method = this.httpMethodTarget.value
    if (url.indexOf(':') >= 0) {
      alert("Please replace all variables (example: ':id') in the URL with content");
      return false;
    }
    if ((method !== 'GET') && !window.confirm('Execute API Request?')) { return false; }
    return true;
  }

  performRequest() {
    const url = this.urlTarget.value
    const method = this.httpMethodTarget.value
    const headers = {
      "Authorization": `Bearer ${this.apiTokenTarget.value}`,
      "Content-Type": "application/json; charset=utf-8"
    };

    const request = new Request(url, {
      method: method,
      headers: headers,
      body: method.toUpperCase() !== "GET" ? this.jsonInputTarget.value  : undefined
    });

    this.showRequest(request)

    // fetch(url, {
    //   method,
    //   headers,
    //   body: method.toUpperCase() !== "GET" ? this.jsonInputTarget.value  : undefined
    // })
    fetch(request)
    .then(response => {
      return response.text().then(text => ({
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text
      }));
    })
    .then(({status, statusText, headers, body}) => {
      const headerText = [...headers].map(([k, v]) => `${k}: ${v}`).join("\n");
      const result = `HTTP ${status} ${statusText}\n${headerText}\n\n${body}`;
      this.resultTarget.textContent = result;
      this.resultTarget.classList.remove("hidden");
    })
    .catch(error => {
      const result = `Error: ${error.message}`;
      this.resultTarget.textContent = result;
      this.resultTarget.classList.remove("hidden");
    });
  }

  showRequest(request) {
    let content = `${request.method} ${request.url}\n`
    for (const [key, value] of request.headers.entries()) {
      content += `${key}: ${value}\n`;
    }
    this.requestTarget.textContent = content
    this.requestTarget.classList.remove("hidden")
  }

  submitTest() {
    event.preventDefault();
    if (!this.validateInput()) { return; }

    // store_entered_tokens();
    this.showSpinner();
    this.performRequest();
  }
}
